import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles scroll restoration on navigation
 * This is especially important for handling browser back/forward navigation
 */
export default function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Save the current scroll position with the pathname as key
    const saveScrollPosition = () => {
      const scrollY = window.scrollY;
      sessionStorage.setItem(`scrollPosition-${pathname}`, scrollY.toString());
    };

    // Add event listener before unmounting
    window.addEventListener('beforeunload', saveScrollPosition);

    // Scroll to top on new navigation
    if (!sessionStorage.getItem(`scrollPosition-${pathname}`)) {
      window.scrollTo(0, 0);
    }

    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, [pathname]);

  return null;
} 